export const stripQueryParams = (url) => {
  if (!url || typeof url !== "string") return url;
  return url.split("?")[0];
};

export const normalizeVideoUrl = (url) => {
  if (!url || typeof url !== "string") return url;

  let cleanUrl = stripQueryParams(url.trim());

  if (cleanUrl.includes(".mp4") && cleanUrl.includes("/index.m3u8")) {
    cleanUrl = cleanUrl.split(".mp4")[0] + ".mp4";
  }

  if (cleanUrl.includes("linx.isilive.ca") && cleanUrl.includes(".mp4")) {
    const pathMatch = cleanUrl.match(/\/live\/(.+\.mp4)/);
    if (pathMatch) {
      cleanUrl = `https://video.isilive.ca/${pathMatch[1]}`;
    }
  }

  return cleanUrl;
};

export const sanitizeRokuUrl = (url) => {
  if (!url || typeof url !== "string") return url;

  let cleanUrl = stripQueryParams(url);

  if (cleanUrl.includes(".mp4") && cleanUrl.includes("/index.m3u8")) {
    cleanUrl = cleanUrl.split(".mp4")[0] + ".mp4";
  }

  if (cleanUrl.endsWith(".mp4") || cleanUrl.endsWith("/index.m3u8")) {
    return cleanUrl;
  }

  if (
    cleanUrl.includes("linx.isilive.ca/live/") &&
    !cleanUrl.endsWith("/index.m3u8")
  ) {
    return cleanUrl.endsWith("/")
      ? cleanUrl + "index.m3u8"
      : cleanUrl + "/index.m3u8";
  }

  return cleanUrl;
};

export const isIsiLivePlayerUrl = (url) => {
  return (
    typeof url === "string" && url.startsWith("https://player.isilive.ca/play/")
  );
};

export const getEmbedVideoUrl = (url) => {
  const normalizedUrl = normalizeVideoUrl(url);

  if (!normalizedUrl) return normalizedUrl;
  if (
    normalizedUrl.includes("youtube.com/embed/") ||
    normalizedUrl.includes("youtu.be/")
  ) {
    return normalizedUrl;
  }
  if (normalizedUrl.startsWith("https://video.isilive.ca/play/")) {
    return `${normalizedUrl}?auto_hide=true`;
  }
  if (isIsiLivePlayerUrl(normalizedUrl)) {
    return normalizedUrl;
  }
  if (normalizedUrl.startsWith("http")) {
    return normalizedUrl;
  }
  return `https://video.isilive.ca/play/${normalizedUrl}?auto_hide=true`;
};
